/* do not edit. this file is generated by npm run lib:icons and constantly overwritten */
import React from 'react'
/**
 * @deprecated Use icons from `@chilipiper/icons/figma-generated/src/icon` or
 *   `@chilipiper/icons/figma-generated/src/logo` instead
 */
export const SvgMicrosoftTeams = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#clip0)'>
      <path
        d='M11.16 6.08139H15.2929C15.6833 6.08139 15.9998 6.39791 15.9998 6.78836V10.5528C15.9998 11.9879 14.8365 13.1512 13.4015 13.1512H13.3892C11.9542 13.1514 10.7907 11.9882 10.7905 10.5532C10.7905 10.5531 10.7905 10.553 10.7905 10.5528V6.45088C10.7905 6.24682 10.956 6.08139 11.16 6.08139Z'
        fill='#5059C9'
      />
      <path
        d='M13.9535 5.33718C14.8782 5.33718 15.6279 4.58752 15.6279 3.66276C15.6279 2.73801 14.8782 1.98834 13.9535 1.98834C13.0287 1.98834 12.2791 2.73801 12.2791 3.66276C12.2791 4.58752 13.0287 5.33718 13.9535 5.33718Z'
        fill='#5059C9'
      />
      <path
        d='M8.74429 5.33721C10.0801 5.33721 11.1629 4.25437 11.1629 2.91861C11.1629 1.58285 10.0801 0.5 8.74429 0.5C7.40853 0.5 6.32568 1.58285 6.32568 2.91861C6.32568 4.25437 7.40853 5.33721 8.74429 5.33721Z'
        fill='#7B83EB'
      />
      <path
        d='M11.9693 6.08139H5.14731C4.76151 6.09094 4.45632 6.41111 4.46527 6.79693V11.0905C4.41139 13.4058 6.24311 15.3271 8.5583 15.3837C10.8735 15.3271 12.7052 13.4058 12.6513 11.0905V6.79693C12.6603 6.41111 12.3551 6.09094 11.9693 6.08139Z'
        fill='#7B83EB'
      />
      <path
        opacity={0.1}
        d='M8.9304 6.08139V12.0981C8.92855 12.374 8.76135 12.6219 8.50622 12.727C8.42498 12.7613 8.33768 12.779 8.24947 12.7791H4.79273C4.74436 12.6563 4.69971 12.5335 4.66249 12.407C4.53224 11.98 4.46578 11.5362 4.46528 11.0898V6.79581C4.45634 6.41061 4.76103 6.09094 5.14621 6.08139H8.9304Z'
        fill='black'
      />
      <path
        opacity={0.2}
        d='M8.55851 6.08139V12.4702C8.55849 12.5584 8.54078 12.6457 8.50641 12.727C8.40135 12.9821 8.15347 13.1493 7.87754 13.1512H4.96764C4.90437 13.0284 4.84484 12.9056 4.79274 12.7791C4.74064 12.6526 4.69972 12.5335 4.6625 12.407C4.53225 11.98 4.46578 11.5362 4.46528 11.0898V6.79581C4.45633 6.41061 4.76104 6.09094 5.14624 6.08139H8.55851Z'
        fill='black'
      />
      <path
        opacity={0.2}
        d='M8.5585 6.08139V11.726C8.55567 12.1009 8.25245 12.4041 7.87754 12.407H4.6625C4.53225 11.98 4.46578 11.5362 4.46528 11.0898V6.79581C4.45633 6.41061 4.76104 6.09094 5.14624 6.08139H8.5585Z'
        fill='black'
      />
      <path
        opacity={0.2}
        d='M8.18621 6.08139V11.726C8.18337 12.1009 7.88017 12.4041 7.50528 12.407H4.66249C4.53224 11.98 4.46578 11.5362 4.46528 11.0898V6.79581C4.45634 6.41061 4.76103 6.09094 5.14621 6.08139H8.18621Z'
        fill='black'
      />
      <path
        opacity={0.1}
        d='M8.93026 4.15775V5.32987C8.867 5.33359 8.80747 5.33732 8.74421 5.33732C8.68095 5.33732 8.62142 5.3336 8.55816 5.32987C8.43256 5.32154 8.308 5.30161 8.18607 5.27034C7.43258 5.09189 6.81007 4.56345 6.51165 3.84891C6.4603 3.72891 6.42044 3.60432 6.39258 3.47681H8.24932C8.6248 3.47823 8.92883 3.78226 8.93026 4.15775Z'
        fill='black'
      />
      <path
        opacity={0.2}
        d='M8.55818 4.52978V5.32975C8.43257 5.32142 8.30799 5.30149 8.18605 5.27022C7.43249 5.09179 6.80993 4.56337 6.51147 3.84888H7.87718C8.25269 3.8503 8.55675 4.15432 8.55818 4.52978Z'
        fill='black'
      />
      <path
        opacity={0.2}
        d='M8.55818 4.52978V5.32975C8.43257 5.32142 8.30799 5.30149 8.18605 5.27022C7.43249 5.09179 6.80993 4.56337 6.51147 3.84888H7.87718C8.25269 3.8503 8.55675 4.15432 8.55818 4.52978Z'
        fill='black'
      />
      <path
        opacity={0.2}
        d='M8.18589 4.52978V5.27024C7.4324 5.0918 6.8099 4.56337 6.51147 3.84885H7.50496C7.88044 3.85027 8.18446 4.1543 8.18589 4.52978Z'
        fill='black'
      />
      <path
        d='M0.682043 3.84885H7.50399C7.88068 3.84885 8.18604 4.15421 8.18604 4.53089V11.3528C8.18604 11.7295 7.88067 12.0349 7.50399 12.0349H0.682043C0.305358 12.0349 0 11.7295 0 11.3528V4.53089C0 4.15421 0.305365 3.84885 0.682043 3.84885Z'
        fill='url(#paint0_linear)'
      />
      <path
        d='M5.88781 6.44521H4.52408V10.1588H3.65525V6.44521H2.29785V5.72482H5.88781V6.44521Z'
        fill='white'
      />
    </g>
    <defs>
      <linearGradient
        id='paint0_linear'
        x1={1.42208}
        y1={3.31591}
        x2={6.76397}
        y2={12.5678}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#5A62C3' />
        <stop offset={0.5} stopColor='#4D55BD' />
        <stop offset={1} stopColor='#3940AB' />
      </linearGradient>
      <clipPath id='clip0'>
        <rect width={16} height={14.8837} fill='white' transform='translate(0 0.5)' />
      </clipPath>
    </defs>
  </svg>
)
export default SvgMicrosoftTeams
